/**
 * i18n — Deutsch (de) ✅ COMPLETE
 */

const de = {
  appTitle: 'Tarkov Money Maker 2',
  modeBadgePvp: 'PvP',
  modeBadgePve: 'PvE',
  modeBadgeSeason: 'Saison 1',
  loading: 'Laden',
  filterSearchLabel: 'Suche',
  filterSearchPlaceholder: 'Itemname, Enter oder klicken…',
  filterSearchAddTerm: 'Weiteren Begriff hinzufügen…',
  filterSearchAdd: 'hinzufügen',
  filterProfitLabel: 'Min. Gewinn',
  filterLevelLabel: 'Spielerlevel',
  filterOffersLabel: 'Min. Angebote',
  filterOffersDisabled: 'API liefert für diesen Modus keine Angebotsanzahl. Filter deaktiviert.',
  traderEnable: 'aktivieren',
  traderDisable: 'deaktivieren',
  intelNotBuilt: 'Nicht gebaut',
  intelLevel1: 'Stufe 1',
  intelLevel2: 'Stufe 2',
  intelLevel3: '-30% Flea-Gebühr',
  colItem: 'Item',
  colBuyTrader: 'Kauf Händler',
  colSellTrader: 'Verkauf Händler',
  colAction: 'Aktion',
  colBestProfit: '★ Bester Gewinn',
  colTraderFlea: 'Händler→Flea',
  colFleaTrader: 'Flea→Händler',
  colFlea: 'Flea',
  copyToast: 'Kopiert!',
  tooltipBuyPrices: 'Händler-Kaufpreise',
  tooltipSellPrices: 'Verkaufspreise',
  flea24h: 'Flea — 24h',
  fleaCur: 'Aktuell',
  fleaLow: 'Tief 24h',
  fleaAvg: 'Ø 24h',
  fleaHigh: 'Hoch 24h',
  fleaOffers: 'Angebote',
  recFTS: 'Flea kaufen → Händler verkaufen',
  recBTF: 'Händler kaufen → Flea verkaufen',
  cardBuy: 'Kauf',
  cardSell: 'Verkauf',
  cardOffers: 'Angebote',
  paginationOf: 'von',
  paginationPerPage: 'Pro Seite:',
  paginationPage: 'Seite',
  paginationTapSort: 'Tippen zum Sortieren',
  noItems: 'Keine profitablen Items gefunden. Schwellenwert senken oder mehr Händler aktivieren.',
  chartTitle: 'Flea — 24h Snapshot',
  chartNoData: 'Unzureichende Daten',
  apiStatusTitle: 'Sync-Status',
  apiStatusOnline: 'tarkov.dev Online',
  apiStatusDegraded: 'tarkov.dev Beeinträchtigt',
  apiStatusOffline: 'tarkov.dev Offline',
  apiStatusChecking: 'Prüfen…',
  apiStatusGlobal: 'Globaler Status',
  apiStatusLastSync: 'Letzte Sync',
  apiStatusItems: 'Synchronisierte Items',
  apiStatusItemsSub: 'gesamt kumuliert',
  apiStatusSource: 'API-Quelle',
  apiStatusSourceSub: 'Auto-Check alle 30s',
  apiStatusCheckedAt: 'Geprüft',
  apiStatusModeStatus: 'Status',
  apiStatusModeItems: 'Items',
  apiStatusModeLastSync: 'Letzte Sync',
  apiStatusModeDuration: 'Dauer',
  apiStatusNever: 'nie',
  apiStatusJustNow: 'gerade eben',
  apiStatusTimeAgoPrefix: 'vor',
  apiStatusMinutesAgo: 'Min',
  apiStatusHoursAgo: 'Std',
  apiStatusRest: 'REST',
  exportCSV: 'CSV exportieren',
  exportJSON: 'JSON exportieren',
  histFleaPrice: 'Flea-Preis — letzte 24h',
  histOffers: 'Angebote — letzte 24h',
  histLoading: 'Verlauf wird geladen…',
  histNoData: 'Noch keine Verlaufsdaten — werden nach jeder Sync gesammelt.',
  histError: 'Server nicht erreichbar — Verlaufsdaten verfügbar, sobald das Backend läuft.',
};

export default de;
